import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { statusObj } from 'src/app/dummy/status';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { IMajor } from 'src/app/interfaces/country';
import { pageKey, checkExist, orderBy } from 'src/app/services/mapping.service';
import { AuthService } from 'src/app/auth/auth.service';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-add-major',
  templateUrl: './add-major.component.html',
  styleUrls: ['./add-major.component.scss']
})
export class AddMajorComponent implements OnInit {
  @ViewChild('focusInput', { static: false }) inputEl: ElementRef;

  form: FormGroup;
  name: AbstractControl;
  shortName: AbstractControl;
  khmerName: AbstractControl;
  description: AbstractControl;
  degree: AbstractControl;

  DEGREE_LIST: any;
  constructor(public dialogRef: MatDialogRef<AddMajorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
        public auth: AuthStore,
    public ds: DataService,
    private snackBar: MatSnackBar,
    public store: List
  ) { }

  buildForm(): void {
    this.form = this.fb.group({
      name: [null, Validators.compose([Validators.required]), checkExist(this.ds.dbRef(), "majors", "name")],
      shortName: [null, Validators.required],
      degree: [null, Validators.required],
      khmerName: [null],
      description: [null],
    });
    this.shortName = this.form.controls['shortName'];
    this.name = this.form.controls['name'];
    this.description = this.form.controls['description'];
    this.khmerName = this.form.controls['khmerName'];
    this.degree = this.form.controls['degree']
  }

  async ngOnInit() {
    this.buildForm();
    const {UNIVERSITY_LEVEL}=this.auth.config;
    this.DEGREE_LIST = orderBy(await this.store.fetchList(this.ds.degreeRef(ref => ref.where('levelKey', "==",UNIVERSITY_LEVEL ))), "order")
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.key === o2.key : o1 === o2;
  }

  create(f: any, isNew) {
    if (this.form.valid) {
      const { shortName, khmerName, description, name,degree } = f;
      const {UNIVERSITY_LEVEL}=this.auth.config;
      const item: IMajor = {
        key: this.ds.createId(),
        page_key: pageKey(),
        created_date: new Date(),
        created_by: this.ds.userRef().doc(`${this.auth.user.uid}`).ref,
        isDeleted: false,
        name: name,
        khmerTitle: khmerName,
        description: description,
        status: statusObj.active,
        shortName: shortName,
        degreeArrayRef:degree.map(m=>{return this.ds.degreeRef().doc(m.key).ref}),
        degreeArrayKey:degree.map(m=>(m.key)),
        levelKey:UNIVERSITY_LEVEL,
        levelRef:this.ds.levelRef().doc(UNIVERSITY_LEVEL).ref,
        facultyKey:this.data,
        facultyRef:this.ds.facultyRef().doc(this.data).ref,
      }
      this.store.save(this.ds.majorRef(), item, (success, error) => {
        if (success) {
          if (!isNew) {
            this.dialogRef.close();
          }
          this.snackBar.open('Major has been created successfully.', 'Done', { duration: 3000 });
          this.form.reset();
          this.inputEl.nativeElement.focus();
        } else {
          this.snackBar.open(error, 'Error');
        }
      });
    }
  }

}
